import acm from "../images/acm.svg";
import pnab from "../images/elevate.jpeg";
import pict from "../images/pict_logo.png";

export const organizationsData = [
  {
    date: "JUNE 2023 - JUNE 2024",
    position: "Student Head",
    name: "Training & Placement Cell",
    logo: pict,
  },{
    date: "FEBRUARY 2021 - May 2024",
    position: "Member",
    name: "PICT ACM Student Branch (ACM)",
    logo: acm,
  },
  {
    date: "JUNE 2023 - JULY 2024",
    position: "Organizing Committee Head",
    name: "ELEVATE ANNUAL SPORTS TOURNAMENT, PICT",
    logo: pnab,
  },
];
